import React from 'react';
import ScoreBadges from '../search/components/results/score_badges';
import type { CallListItem } from 'bundles/connect/types';

type CallListOffMarketSummaryProps = {
  callListItem: CallListItem;
  lastUpdated?: string;
}

export default function CallListOffMarketSummary({ callListItem, lastUpdated }: CallListOffMarketSummaryProps) {
  const addressArray = callListItem.callListable.name.split(',');
  return (
    <div className="d-flex flex-column justify-content-md-between gap-3 gap-md-2 h-100">
      <div className="clickable-text lh-sm">
        <div className="fw-bolder result-address">{addressArray[0]}</div>
        <small>{addressArray[1]}, {addressArray[2]} {addressArray[3]}</small>
      </div>
      <div className="small text-muted lh-sm">
        <span>
          {lastUpdated ? `Last Outreach: ${new Date(lastUpdated).toLocaleString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
          })}` : 'No Outreach'} •
          {callListItem.numContacts >= 0 ? ` ${callListItem.numContacts} Contacts` : ' Unlock Contacts'}
        </span>
      </div>
      <ScoreBadges scores={callListItem.callListable.scores} />
    </div>
  );
}
